<script lang="ts">
    import type {FieldTypeId} from 'src/typings';
    import {SearchFieldTypeFilter} from 'src/features/search/kp-search-field-type-filter';
    import {exists} from 'shared/utils/custom-utils';

    export let text: string;
    export let label: string | null = null;
    export let fieldTypeId: FieldTypeId | null = null;

    $: title = exists(label) ? `${label} - ${text}` : text;
</script>

{#if exists(fieldTypeId)}
    <SearchFieldTypeFilter {fieldTypeId}>
        <span class="cell-title" {title}>{text}</span>
    </SearchFieldTypeFilter>
{:else}
    <span class="title-container">
        <span class="cell-title" {title}>{text}</span>
    </span>
{/if}

<style lang="less">
    .title-container {
        display: flex;
        align-items: center;
    }

    .cell-title {
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-align: start;
    }
</style>